<script>
import Navbar from "@/components/navbar";
import Services from "@/components/services";
// import Features from "@/components/features";
// import Pricing from "@/components/pricing";
// import Team from "@/components/team";
// import Blog from "@/components/blog";
// import Contact from "@/components/contact";
import Footer from "@/components/footer";

/**
 * index-1 component
 */
export default {
  name: "index-1",
  components: {
    Navbar,
    Services,
    // Features,
    // Pricing,
    // Team,
    // Blog,
    // Contact,
    Footer,
  },
};
</script>

<template>
  <div>
    <Navbar/>
    <div v-scroll-spy>
      <!--START HOME-->
      <section
          class="section bg-home home-half"
          id="home"
          :style="{'background-image': 'url(' + require('@/assets/images/bg-image3.jpg') + ')', 'background-size': 'cover','background-position': 'center' }"
      >
        <div class="bg-overlay"></div>

        <div class="display-table">
          <div class="display-table-cell">
            <div class="container">
              <div class="row">
                <div class="col-lg-12 text-white text-center">

                  <h1 class="home-title" style="text-transform: uppercase;">
                    Davlat organlari va tashkilotlarining yuridik xizmatdagi boʼsh ish oʼrinlari haqida maʼlumotlar</h1>
                  <!--                  <p-->
                  <!--                      class="padding-t-15 home-desc"-->
                  <!--                  >Mamlakatimizda kuchli huquqiy davlat barpo etish, fuqarolarning huquqiy ongi va madaniyatini-->
                  <!--                    yuksaltirish, davlat hokimiyati va boshqaruvi organlari hamda хoʻjalik yurituvchi sub’yektlar-->
                  <!--                    faoliyatida qonun ustuvorligini ta’minlashda yuridik хizmat muhim ro'l oʻynaydi.-->
                  <!--                  </p>-->
                  <!--                  <p class="play-shadow margin-t-30 margin-l-r-auto">-->
                  <!--                    <a v-b-modal.modal href="javascript: void(0);" class="play-btn video-play-icon">-->
                  <!--                      <i class="mdi mdi-play text-center"></i>-->
                  <!--                    </a>-->
                  <!--                  </p>-->
                  <!--                  <div class="footer-social-icon single-cta mt-3" style="margin-bottom: -50px">-->

                  <!--                    <b-row>-->
                  <!--                      <b-col cols="3" class="float-right"></b-col>-->
                  <!--                      <b-col cols="2" class="float-right">-->
                  <!--                        <a href="https://advice.uz" target="_blank">-->
                  <!--                          <img src="../assets/advice-removebg-preview.png"-->
                  <!--                               style="background-color: #2564AB; cursor: pointer; border-radius: 5px" alt=""-->
                  <!--                               class="img-fluid mx-auto d-block mt-3">-->
                  <!--                        </a>-->
                  <!--                      </b-col>-->
                  <!--                      <b-col cols="3" class="float-right" style="margin-top: 15px">-->
                  <!--                        <a href="https://www.minjust.uz" target="_blank" class="pr-3 iconStyle" >-->
                  <!--                          <i class="fas fa-globe fa-2x" ></i>-->
                  <!--                        </a>-->
                  <!--                        <a href="info@adliya.uz" target="_blank" class="p-2 iconStyle">-->
                  <!--                          <i class="far fa-envelope-open  fa-2x"></i>-->
                  <!--                        </a>-->
                  <!--                        <a href="https://www.facebook.com/groups/adliya/" target="_blank" class="pl-3 iconStyle">-->
                  <!--                          <i class="fab fa-facebook-square  fa-2x"></i>-->
                  <!--                        </a>-->
                  <!--                        <a href="https://t.me/huquqiyaxborot" target="_blank" class="pl-3 iconStyle" style="margin-right: -50px">-->
                  <!--                          <i class="fab fa-telegram  fa-2x"></i>-->
                  <!--                        </a>-->
                  <!--                      </b-col>-->
                  <!--                      <b-col cols="2" class="float-left">-->

                  <!--                        <a href="https://lex.uz/ru/" target="_blank">-->
                  <!--                          <img src="../assets/lex-removebg-preview.png"-->
                  <!--                               style="width: 80px; height: 80px; cursor: pointer" alt=""-->
                  <!--                               class="img-fluid mx-auto d-block">-->
                  <!--                        </a>-->
                  <!--                      </b-col>-->
                  <!--                      <b-col cols="2" class="float-right"></b-col>-->
                  <!--                    </b-row>-->
                  <!--                  </div>-->
                  <!--                  <b-modal id="modal" hide-footer size="lg" centered header-close-variant="white">-->
                  <!--                    <youtube video-id="RnDC9MXSqCY" ref="youtube" width="750" height="450"></youtube>-->
                  <!--                  </b-modal>-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="wave-effect wave-anim">
          <div class="waves-shape shape-one">
            <div
                class="wave wave-one"
                :style="{'background-image': 'url('+ require('@/assets/images/wave-shape/wave1.png')+ ')'}"
            ></div>
          </div>
          <div class="waves-shape shape-two">
            <div
                class="wave wave-two"
                :style="{'background-image': 'url('+ require('@/assets/images/wave-shape/wave2.png')+ ')'}"
            ></div>
          </div>
          <div class="waves-shape shape-three">
            <div
                class="wave wave-three"
                :style="{'background-image': 'url('+ require('@/assets/images/wave-shape/wave3.png')+ ')'}"
            ></div>
          </div>
        </div>
        <!--        <div class="bg-pattern-effect">-->
        <!--          <img src="@/assets/images/bg-pattern.png" alt />-->
        <!--        </div>-->
      </section>
      <!--END HOME-->
      <Services/>
      <!--      <Features/>-->
      <!--      <Pricing/>-->
      <!--      <Team/>-->
<!--      <Blog/>-->
      <!--      <Contact/>-->
      <Footer/>
    </div>
  </div>
</template>

<style scoped>
::v-deep .modal-content {
  background-color: #000000;
  color: white;
  background: none;
  border: none;
}

::v-deep .modal-header {
  border: none;
}

::v-deep .modal-backdrop {
  opacity: 0.5;
}

</style>
